// [Written 10 Apr 2024] Adding this because of the limited browser capability of new set functions
// E.G. .intersection, .union, .difference (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/intersection)
// A similar class exists in nb-api. This is different to match the new mdn Set API
// and it is not refactored into nb-common b/c the transpiler breaks the code if its imported from there...

export class NbSet<T> extends Set<T> {
  static get emptySet() {
    return new NbSet([]);
  }

  eql<E extends Set<T>>(s: E) {
    return this.size === s.size && [...s].every((val) => this.has(val));
  }

  difference<E extends Set<T>>(s: E) {
    return new NbSet([...this].filter((x) => !s.has(x)));
  }

  intersection<E extends Set<T>>(s: E) {
    return new NbSet([...this].filter((x) => s.has(x)));
  }

  union<E extends Set<T>>(s: E) {
    return new NbSet([...this, ...s]);
  }
}
